<template>
  <el-menu
    :default-active="defaultActive"
    class="el-menu-vertical-demo"
    @open="handleOpen"
    :router='true'
    @close="handleClose"
    background-color="#545c64"
    text-color="#fff"
    active-text-color="#ffd04b"
    :collapse="opened"
    :collapse-transition="false">
    <template v-for="(menu, index1) in memus">
      <el-submenu :key="index1" :index="`${menu.menuUrl}`" v-if="menu.childMenus&&menu.childMenus.length>0">
        <template slot="title">
          <i :class="menu.menuIcon"></i>
          <span slot="title">{{menu.menuName}}</span>
        </template>

        <template v-for="(submenu, index2) in menu.childMenus">
          <el-menu-item v-if="!submenu.childMenus||submenu.childMenus.length===0" :key="index2"
                        :route="submenu.menuUrl"
                        :index="`${submenu.menuUrl}`">{{submenu.menuName}}
          </el-menu-item>
          <el-submenu :key="index2" :index="`${submenu.menuUrl}`" v-else>
            <template slot="title">
             <!-- <i :class="submenu.menuIcon"></i> -->
              <span slot="title">{{submenu.menuName}}</span>
            </template>
            <template v-for="(submenu1, index3) in submenu.childMenus">
              <el-menu-item :key="index3"
                            :route="submenu1.menuUrl"
                            :index="`${index1+1}-${index2+1}-${index3+1}`">
                {{submenu1.menuName}}
              </el-menu-item>

            </template>

          </el-submenu>
        </template>
      </el-submenu>
      <el-menu-item  :route="menu.menuUrl" v-else :key="index1" :index="`${menu.menuUrl}`">
        <i :class="menu.menuIcon"></i>
        <span slot="title">{{menu.menuName}}</span>
      </el-menu-item>
    </template>
  </el-menu>

</template>

<script>
import { mapGetters } from 'vuex'
import { listOwnerMenu } from '@/api/modelManager'
import { eventBus } from '@/utils/eventBus'
import {
  getServiceId
} from '@/api/fileServer'
export default {
  name: 'SideBar',
  data () {
    return {
      isCollapse: false,
      defaultActive: '',
      memus: []
      /* memus: [
        {
          title: '首页',
          icon: 'el-icon-house',
          path: '/home'
        },
        {
          title: '产品管理',
          icon: 'el-icon-setting',
          path: '/productControl',
          subMenus: [
            {
              title: 'SN管理',
              path: '/productControl/snManagement',
              icon: 'el-icon-location'
            },
            {
              title: '产品注册',
              path: '/productControl/productRegistration',
              icon: 'el-icon-location'
            },
            {
              title: 'CA证书',
              path: '/productControl/CACertificate',
              icon: 'el-icon-location'
            }
          ]
        },
        {
          title: '设备管理',
          path: '/deviceManagement/DeviceManager',
          icon: 'el-icon-s-operation'
        },
        {
          title: '模板管理',
          icon: 'el-icon-document',
          path: '/template',
          subMenus: [
            {
              title: '角色模板',
              path: '/template/role',
              icon: 'el-icon-location'
            },
            {
              title: '厂商模板',
              path: '/template/business',
              icon: 'el-icon-location'
            }
          ]
        },
        {
          title: '数据统计',
          path: '/dataStatistics',
          icon: 'el-icon-s-data'
        },
        {
          title: '规则引擎',
          path: '/ruleEngine',
          icon: 'el-icon-s-cooperation',
          subMenus: [
            {
              title: '场景联动',
              path: '/ruleEngine/sene',
              icon: 'el-icon-location'
            }
          ]
        },
        {
          title: '系统运维',
          path: '/systemopra',
          icon: 'el-icon-s-platform',
          subMenus: [
            {
              title: '实时监控',
              path: '/sytem/systemopra',
              icon: 'el-icon-location'
            },
            {
              title: '日志服务',
              path: '/sytem/logService'
            },
            {
              title: '固件升级',
              path: '/SystemOper/firmwareUpdate',
              icon: 'el-icon-location'
            }
          ]
        },
        {
          title: '系统管理',
          path: '/system',
          icon: 'el-icon-menu',
          subMenus: [
            {
              title: '角色管理',
              path: '/systemManagement/charactorManager',
              icon: 'el-icon-location'
            },
            {
              title: '用户管理',
              path: '/systemManagement/userManager',
              icon: 'el-icon-location'
            },
            {
              title: '权限管理',
              path: '/systemManagement/permissionManager',
              icon: 'el-icon-setting'
            },
            {
              title: '模块管理',
              path: '/systemManagement/modelManager',
              icon: 'el-icon-location'
            },
            {
              title: '密码修改',
              path: '/systemManagement/pwdUpdate',
              icon: 'el-icon-location'
            }
          ]
        },
        {
          title: '关于我们',
          path: '/about',
          icon: 'el-icon-user',
          subMenus: [
            {
              title: '公司介绍',
              path: '/about',
              icon: 'el-icon-location'
            },
            {
              title: '产品介绍',
              path: '/hello',
              icon: 'el-icon-location'
            }
          ]
        }
      ] */
    }
  },
  computed: {
    ...mapGetters(['opened'])
  },
  watch: {
    $route () {
      if (/hasParent/.test(this.$route.name)) {
        this.defaultActive = this.$route.name.substr(9)
      } else {
        this.defaultActive = this.$route.path
      }
    }
  },
  mounted () {
    // console.log('menus=====', this.memus)
    // console.log('window.location.pathname:', window.location.pathname)
    // this.defaultActive = window.location.pathname
    const obj = this
    // console.log(this.opened)
    if (/hasParent/.test(obj.$route.name)) {
      obj.defaultActive = obj.$route.name.substr(9)
    } else {
      obj.defaultActive = obj.$route.path
    }
  },
  created () {
    // this.getUrl()
    this.getMenuList()
    eventBus.$on('updataMentList', this.getMenuList)
    this.getServiceId()
  },
  methods: {
    /* getUrl () {
      this.defaultActive = window.location.pathname
    }, */
    // 登录完成之后统一调用一次获取serverid，用于切片上传
    getServiceId () {
      getServiceId().then(res => {
        res = res.data
        console.log('servieceid登录后获取:', res)
        if (res.code === 200) {
          // this.serviceId = res.data
          this.$store.commit('SET_FILE_SERVICE_ID', res.data)
        }
      })
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    getMenuList () {
      listOwnerMenu().then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          this.memus = res.data.data
          this.$store.commit('SET_LIST_OWNER_MENU', JSON.stringify(res.data.data))// 把用户对应的菜单缓存起来，很多地方用到,缓存成字符串，方式修改操作到对象
          const parentArr = [] // 父级权限
          const childrenArr = [] // 子级权限
          res.data.data.forEach(ele => {
            parentArr.concat(ele.buttonList)
            if (ele.childMenus && ele.childMenus.length > 0) {
              ele.childMenus.forEach(item => {
                if (item.buttonList && item.buttonList.length > 0) {
                  item.buttonList.forEach((el) => {
                    childrenArr.push(el.buttonValue)
                  })
                }
              })
            }
          })
          sessionStorage.setItem('promissions', JSON.stringify(childrenArr)) // 会话储存按钮/权限
        }
      })
    }
  }
}
</script>

<style scoped>
  .el-menu--collapse{
    height: 100%;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    overflow-x: hidden;
    height: 100%;
  }
  .el-menu{
    border: none;
  }
  /*.el-menu-item.is-active {*/
  /*  background-color: rgb(113, 131, 153) !important;*/
  /*}*/
</style>
